import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DataTable from 'react-data-table-component';
import { set, useForm } from 'react-hook-form';
import axios from 'axios';
import { ConfirmationAlert, triggerAlert, getOnlyToken } from '../../utils/commonFunctions';
import { _get, DeleteAgentByID, getFolders } from '../../utils/APIClient';
import Header from '../../common/Header';
import Sidebar from '../../common/Sidebar';
import PageHeader from '../PageHeader';
import Cookies from 'js-cookie';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Typography,

    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Skeleton,
    Menu,
    MenuItem,
    Snackbar,
    Alert,
    Divider,
} from '@mui/material';
import Loader from '../../common/Loader';

export default function ChatbotsList() {
    document.title = "Digital Employees | Chatbot Agents"
    const [ListofAiAgents, setListofAiAgents] = useState([])
    const [agentLoading, setAgentLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [showCreateAgentModal, setShowCreateAgentModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const access_privileges = JSON.parse(Cookies.get("modulepermissions"))
    const [customerlist, setcustomerlist] = useState(false)
    const [customeradd, setcustomeradd] = useState(false)
    const [customeredit, setcustomeredit] = useState(false)
    const [customerdelete, setcustomerdelete] = useState(false)
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [creditCostDialogOpen, setCreditCostDialogOpen] = useState(false);
    const [creditCostValue, setCreditCostValue] = useState("");
    const [creditCostId, setCreditCostId] = useState(null);
    const [isUpdatingCreditCost, setIsUpdatingCreditCost] = useState(false);


    const creditcost = async () => {
        try {
            const response = await axios.get('/api/admin/credit-cost-config/?key=clone_chatbot', { withCredentials: true });
            if (response.data.results && response.data.results.length > 0) {
                setCreditCostValue(response.data.results[0].default_cost);
                setCreditCostId(response.data.results[0].id);
            }
        } catch (error) {
            triggerAlert('error', '', error.response?.data?.error || 'Failed to get credit cost');
        }
    }
    useEffect(() => {
        creditcost();
    }, [])

    const handleUpdateCreditCost = async () => {
        setIsUpdatingCreditCost(true);
        try {
            const payload = {
                key: "clone_chatbot",
                default_cost: creditCostValue,
                description: "Default cost for cloning any chatbot"
            };
            if (creditCostId) {
                payload.id = creditCostId;
            }

            // Depending on backend convention, the ID could go in the URL or the payload. We include both to be safe.
            const patchUrl = creditCostId ? `/api/admin/credit-cost-config/${creditCostId}/` : '/api/admin/credit-cost-config/';

            await axios.patch(patchUrl, payload, { withCredentials: true });

            triggerAlert('success', '', 'Credit cost updated successfully!');
            setCreditCostDialogOpen(false);

            // Reload the newly updated cost value
            creditcost();
            // Fetch agents to reflect potential downstream changes
            fetchAgentsForFolder();
        } catch (error) {
            triggerAlert('error', '', error.response?.data?.error || 'Failed to update credit cost');
        } finally {
            setIsUpdatingCreditCost(false);
        }
    };
    // React Hook Form setup
    const { register, handleSubmit, watch, setValue, reset, formState: { errors } } = useForm({
        defaultValues: {
            flow_name: '',
            flow_type: 'in-bound'
        }
    });
    const [newChatbot, setNewChatbot] = useState({
        name: '',
        description: '',
        company_name: '',
    });

    const selectedFlowType = watch('flow_type');

    useEffect(() => {
        fetchAgentsForFolder();

        access_privileges.map((access, i) => {
            access.sub_module_info.map((subaccess, k) => {
                if (subaccess.name == "Chatbot Configurations" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true)
                }
                if (subaccess.name == "Chatbot Configurations" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true)
                }
                if (subaccess.name == "Chatbot Configurations" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true)
                }
                if (subaccess.name == "Chatbot Configurations" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true)
                }

            })


        })
    }, [])
    const menuRef = useRef()


    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedChatbot, setSelectedChatbot] = useState(null);
    const mainHeading = "Chatbots";
    const [embedCode, setEmbedCode] = useState('');
    const heading = `Digital Employee / ${mainHeading}`;
    const [disabled, setDisabled] = useState(false);

    const handleCreateChatbot = async () => {
        setDisabled(true);
        setErrorMessage("")
        if (newChatbot.name == "") {
            setDisabled(false);
            setErrorMessage("Please enter chatbot name");
            return
        }
        try {
            const response = await axios.post('/api/admin/chatbots', newChatbot, { withCredentials: true });
            triggerAlert('success', '', 'Chatbot created successfully!');
            setDisabled(false);
            setCreateDialogOpen(false);
            setNewChatbot({ name: '', description: '', company_name: '' });
            navigate(`/chatbots/${response.data.chatbot.id}`);
        } catch (error) {
            setDisabled(false);
            setErrorMessage(error.response?.data?.error || 'Failed to create chatbot');
            triggerAlert('error', '', error.response?.data?.error || 'Failed to create chatbot');


        }
    };

    const handleDeleteChatbot = async (chatbot) => {

        try {
            await axios.delete(`/api/admin/chatbots/${chatbot.id}`, { withCredentials: true });
            triggerAlert('success', '', 'Chatbot deleted successfully');

            fetchAgentsForFolder();
        } catch (error) {
            triggerAlert('error', '', "Failed to delete chatbot");


        }

    };

    const handleGetEmbedCode = async (chatbot) => {
        try {
            const response = await axios.get(`/api/chatbots/${chatbot.id}/embed-code`, { withCredentials: true });
            setEmbedCode(response.data.embed_script);
            setSelectedChatbot(chatbot);

        } catch (error) {
            triggerAlert('error', '', "Failed to delete chatbot");

        }

    };

    const handleTogglePublish = async (chatbot, event) => {
        if (event) {
            event.stopPropagation();
        }

        const newPublish = !chatbot.publish_status;

        try {
            await axios.put(`/api/admin/chatbots/${chatbot.id}`, {
                publish_status: newPublish
            }, { withCredentials: true });

            triggerAlert(
                'success',
                '',
                `Chatbot ${newPublish ? 'published' : 'unpublished'} successfully`
            );

            fetchAgentsForFolder();
        } catch (error) {
            triggerAlert('error', '', "Failed to update chatbot publish status");
        }
    };

    const handleCopyEmbedCode = () => {
        navigator.clipboard.writeText(embedCode);
        triggerAlert('success', '', 'Embed code copied to clipboard!');


    };


    // Create Agent API call


    const fetchAgentsForFolder = async (pageNum = 1, pageSize = 10) => {
        setAgentLoading(true);
        try {
            const response = await _get(`api/admin/chatbots?page=${pageNum}&page_size=${pageSize}`);
            if (response.status === 200) {
                // assume agents returned in response.data.agents or response.data.data
                const agents = response.data.chatbots || [];
                const pagination = response.data.pagination || {};
                setListofAiAgents(agents);
                setCurrentPage(pagination.page || pageNum);
                setPerPage(pagination.page_size || pageSize);
                setTotalCount(pagination.total_count || 0);
            } else {
                setListofAiAgents([]);
            }
        } catch (error) {
            console.error('Failed to fetch agents for folder', error);
            setListofAiAgents([]);
        } finally {
            setAgentLoading(false);
        }
    };

    const handlePageChange = (page) => {
        fetchAgentsForFolder(page, perPage);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        fetchAgentsForFolder(1, newPerPage);
    };



    const columns = [
        {
            name: "S.NO",
            width: "90px",
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Chatbot Name",
            sortable: true,
            cell: (row) => (
                <div className="d-flex align-items-center gap-2" style={{ maxWidth: "250px" }}>
                    <span
                        className="text-primary fw-bold"
                        title={row.name}
                        style={{
                            maxWidth: "250px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                        }}
                    >
                        {row.name}
                    </span>
                </div>
            ),
        },
        {
            name: 'Avatar Name',
            cell: row => {
                const type = row.avatar_name?.toLowerCase();

                return (
                    <span
                        className={`badge rounded-pill px-3 py-1 fw-semibold 
                    ${type === 'in-bound'
                                ? 'bg-primary-subtle text-primary'
                                : 'bg-success-subtle text-success'
                            }`}
                        style={{ fontSize: '0.75rem' }}
                    >
                        {row.avatar_name}
                    </span>
                );
            },
            sortable: true,
        },
         {
            name: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Chatbot Cost
                </div>
            ),
            selector: row => row.agent_plan?.pack_price || 0,
            sortable: true,
            cell: row => (
                <span>
                    ${row.agent_plan?.pack_price || 0}
                </span>
            ),
        },
          {
            name: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Duration
                </div>
            ),
            selector: row => row.agent_plan?.pack_units || 0,
            sortable: true,
            cell: row => (
                <span>
                    {row.agent_plan?.pack_units || 0} mins
                </span>
            ),
        },
      
        // {
        //     name: 'Status',
        //     width: '100px',
        //     cell: row => (
        //         <span className={`badge rounded-pill px-3 py-1 fw-semibold ${row.status === 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`} style={{ fontSize: '0.75rem' }}>
        //             {row.status === 'active' ? 'Active' : 'Inactive'}
        //         </span>
        //     ),
        // },
        {
            name: 'Publish',
            width: '130px',
            cell: row => (
                <div className="form-check form-switch" onClick={(e) => e.stopPropagation()}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={!!row.publish_status}
                        onChange={(e) => handleTogglePublish(row, e)}
                        style={{ cursor: 'pointer', width: '2.5rem', height: '1.25rem' }}
                    />
                    {/* <span className={`badge rounded-pill ms-1 ${row.is_published ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'}`} style={{ fontSize: '0.7rem' }}>
                        {row.is_published ? 'Published' : 'Unpublished'}
                    </span> */}
                </div>
            ),
        },
        {
            name: 'Created',
            selector: row => row.created_at,
            sortable: true,
            cell: row => moment(row.created_at).fromNow(),
        },
        // {
        //     name: (
        //         <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        //             Credit Cost
        //             {customeredit && (
        //                 <i
        //                     className="bi bi-pencil-square"
        //                     style={{ cursor: 'pointer', fontSize: '1.1rem', color: '#ffffff' }}
        //                     onClick={(e) => {
        //                         e.stopPropagation();
        //                         setCreditCostDialogOpen(true);
        //                     }}
        //                     title="Edit Default Cost (USD)"
        //                 ></i>
        //             )}
        //         </div>
        //     ),
        //     selector: row => row.credits_cost,
        //     sortable: true,
        // },
        {
            name: 'Actions',
            cell: row => (
                <div className="action-container">
                    {/* Edit */}
                    {customeredit && <Link
                        to={`/chatbots/${row.id}`}
                        className="action-btn edit-btn"
                        title="Edit"
                    >
                        <i className="bi bi-pencil-square"></i>
                    </Link>}


                    {/* Delete */}
                    {customerdelete && <span
                        className="action-btn delete-btn"
                        onClick={() => {
                            ConfirmationAlert(
                                "Do you want to delete agent from database",
                                "Delete",
                                () => handleDeleteChatbot(row)
                            );
                        }}
                        title="Delete"
                    >
                        <i className="bi bi-trash-fill"></i>
                    </span>}
                </div>
            ),
        }


    ]
    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };

    return (
        <>

            <div id='layout-wrapper'>
                <Header />
                <Sidebar />
                <div className='page-content' style={{ backgroundColor: "#ededed" }}>

                    <div className="main-content">
                        <PageHeader mainHeading={mainHeading} heading={heading} />
                        <div className=' '>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="page-title-box">
                                            <div className="page-title-right">
                                                <div className="d-flex  justify-content-end ">


                                                    {customeradd ? <button className="btn btn-primary d-flex align-items-center gap-1" onClick={() => { setCreateDialogOpen(true); setNewChatbot({ name: '', description: '', company_name: '' }); setErrorMessage("") }}  >   Create Chatbot </button> : ""}


                                                </div>

                                            </div>
                                            {/* <h4 className="page-title">AI Agents</h4> */}

                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="">
                                            <DataTable
                                                columns={columns}
                                                data={ListofAiAgents}
                                                progressPending={agentLoading}
                                                progressComponent={
                                                    <div className='loader-overlay text-white'>
                                                        <Loader />
                                                    </div>
                                                }
                                                customStyles={customStyles}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalCount}
                                                paginationDefaultPage={currentPage}
                                                paginationPerPage={perPage}
                                                onChangeRowsPerPage={handlePerPageChange}
                                                onChangePage={handlePageChange}
                                                paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                                noDataComponent={<p className="text-muted py-4">No AI Agents found.</p>}
                                                pointerOnHover
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <Dialog
                open={creditCostDialogOpen}
                onClose={() => setCreditCostDialogOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>Update Default Cost (USD)</DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Default Cost ($)"
                            variant="outlined"
                            type="number"
                            inputProps={{ step: "0.0001", min: "0" }}
                            value={creditCostValue}
                            onChange={(e) => setCreditCostValue(e.target.value)}
                            placeholder="e.g., 0.1500"
                            helperText="USD amount with up to 4 decimal places (minimum $0.0001)"
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button onClick={() => setCreditCostDialogOpen(false)} color="secondary">Cancel</Button>
                    <Button
                        onClick={handleUpdateCreditCost}
                        disabled={isUpdatingCreditCost || !creditCostValue}
                        variant="contained"
                        className="btn btn-primary"
                    >
                        {isUpdatingCreditCost ? 'Updating...' : 'Update'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* SUCCESS MODAL */}
            <Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                centered
                backdrop="static"
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Body className="p-4 text-center">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{
                            width: 80,
                            height: 80,
                            background: "linear-gradient(135deg, #28a745, #20c997)",
                        }}
                    >
                        <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
                    </div>
                    <h5 className="fw-bold mb-2">Success</h5>
                    <p className="text-muted mb-4">{successMessage}</p>
                    <button
                        className="btn btn-success px-4 fw-semibold rounded-pill"
                        onClick={() => setShowSuccessModal(false)}
                    >
                        Done
                    </button>
                </Modal.Body>
            </Modal>

            <Dialog
                open={createDialogOpen}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return; // block close
                    }

                    setCreateDialogOpen(false)

                }}

                maxWidth="sm"
                fullWidth
                PaperProps={{
                    elevation: 0,
                    sx: {
                        borderRadius: 2,  // 16px (lg)
                        border: '1px solid rgba(0,0,0,0.08)',
                    },
                }}

            >
                <DialogTitle className='text-primary ' sx={{ fontWeight: 600, pb: 1 }}>

                    Create New Chatbot
                    <IconButton
                        aria-label="close"
                        onClick={() => setCreateDialogOpen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                        Set up your new AI chatbot with basic information
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                        <div className="mb-3">
                            <label className="form-label">
                                Chatbot Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control rounded-2"
                                autoFocus
                                required
                                value={newChatbot.name}
                                onChange={(e) => {
                                    setNewChatbot({ ...newChatbot, name: e.target.value });
                                    if (e.target.value != "") {
                                        setErrorMessage("")
                                    }
                                    else {
                                        setErrorMessage("Please enter chatbot name");
                                    }
                                }


                                }
                                placeholder="e.g., Customer Support Bot"
                            />

                            {errorMessage && <p className="text-danger">{errorMessage}</p>}
                        </div>

                        {/* <div className="mb-3">
  <label className="form-label">Company Name</label>
  <input
    type="text"
    className="form-control rounded-2"
    value={newChatbot.company_name}
    onChange={(e) =>
      setNewChatbot({ ...newChatbot, company_name: e.target.value })
    }
    placeholder="e.g., Acme Inc."
  />
</div> */}

                        <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                                className="form-control rounded-2"
                                rows={3}
                                value={newChatbot.description}
                                onChange={(e) =>
                                    setNewChatbot({ ...newChatbot, description: e.target.value })
                                }
                                placeholder="Describe what this chatbot does..."
                            />
                        </div>

                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>

                    <button
                        onClick={() => setCreateDialogOpen(false)}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <Button
                        onClick={handleCreateChatbot}
                        type='submit'
                        disabled={disabled}

                    >
                        Create Chatbot
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}
